import styled from 'styled-components'
import { device } from 'src/theme/theme'
import { safeAreaTopPadding } from 'src/styles/safeArea'

export const MenuHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  min-height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3;
  transition: all 0.3s ease 0s;
  margin: -2px 0 0 -2px;
  ${safeAreaTopPadding};

  @media ${device.tablet} {
    position: ${'static'};
  }

  &.menu-module.open {
    width: 80%;

    @media ${device.tablet} {
      width: 320px;
    }
  }

  &.menu-module.close {
    width: 0;

    div#help_item {
      .wrapper {
        min-width: 200px;
      }
    }
  }

  &.hidden {
    overflow: hidden;
    @media ${device.mobileL} {
      overflow: visible;
    }
  }
`

export const Content = styled.div`
  .logo {
    display: flex;
    align-items: center;
  }
  @media ${device.tablet} {
    display: block;
  }
`

export const Aside = styled.aside`
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  @media ${device.tablet} {
    overflow: inherit;
  }
`
